<button *ngIf="status" mat-icon-button title="{{status.text | translation:STATUS_MAPPER}}">
  <mat-icon [class.status-icon]="status.animated">{{status.icon}}</mat-icon>
</button>
<span *ngIf="status && showText">{{status.text | translation:STATUS_MAPPER}}</span>
